import React, {memo} from 'react';
import {FormattedMessage} from 'react-intl';

export const LoadingComponent: React.FC = memo(() => <FormattedMessage id="Label.Loading"/>);
